import axios from '@dap/shared-utils/http.js';

export default {
    getLandingPageHeatmap (params = {}) {
        return axios.get('/dapper/api/mat/landing/heat_image', { params });
    },
    getLandingPageList (params = {}) {
        return axios.get('/dapper/api/mat/landings', { params });
    },

    getLandingPageInfo (params = {}) {
        return axios.get('/dapper/api/mat/landing/edit_data', { params });
    },

    updateLandingPage (params = {}) {
        if (params.id && params.id > 0) {
            return axios.put('/dapper/api/mat/edit_landing', params);
        }

        return axios.post('/dapper/api/mat/landing', params);
    },

    deleteLandingPage (params = {}) {
        return axios.delete('/dapper/api/mat/del_landing', { data: params });
    },

    getAuthorList (params = {}) {
        return axios.get('/dapper/api/mat/general/user', { params });
    },

    getTemplateList (params = {}) {
        return axios.get('/dapper/api/mat/landing/templates', { params });
    },

    getPreviewUrl (params = {}) {
        return axios.get('/dapper/api/mat/landing/template_url', { params });
    },

    getAuthorizationBook (params = {}) {
        return axios.get('/dapper/api/review/authorization_book', { params });
    },

    getVendorList () {
        return axios.get('/dapper/api/materiel_2/vendor');
    },

    // 获取蜻蜓建站落地页物料
    getMaterialList (params) {
        return axios.get('/dapper/api/mat/landing/dragonfly_materials', {
            params,
        });
    },
    /**
     * 改变状态
     * dapper/api/mat/landings/switch
     *  PUT
     *  id: int
     *  status: int (0-暂停 1-开启)
     */
    changeStatus (params) {
        return axios.put('/dapper/api/mat/landings/switch ', params);
    },
};
